import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette, spacing }: Theme) => ({
  root: {},
  newSectionStyleRoot: {
    maxWidth: 730,
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: 24,
    marginBottom: 16,
    '&>$heading': {
      margin: '0 0 16px',
      '&>h2': {
        color: `${custom.grey[3]}`,
        fontWeight: '600',
      },
    },
    '&>$formRow:not(div[data-field-key="consent.all.payment"])': {
      maxWidth: '100%',
      width: '100%',
      marginBottom: 0,
      padding: 0,
    },
    '&>div[data-field-key="consent.all.payment"]': {
      maxWidth: '100%',
      width: '100%',
      paddingLeft: 0,
      paddingTop: 16,
      '& label>span>span>span': {
        color: custom.grey[3],
        fontSize: 16,
        fontWeight: 400,
      },
    },
    '& $controlAndLabelWrapper': {
      width: '100%',
    },
    '& label[id="payment.paymentMethod-label"]': {
      fontSize: 18,
      lineHeight: '22px',
      marginBottom: '0 !important',
    },
    '& $compactSectionHeading': {
      color: custom.grey[3],
      fontWeight: 600,
      padding: 0,
    },
    '& #consent-wrapper': {
      padding: '6px 0 0 0',
      maxWidth: '100%',
      width: '100%',
      '&>div': {
        borderRadius: 12,
        '&>div': {
          maxWidth: '100%',
          width: '100%',
        },
      },
      '& label>span>span>span': {
        color: custom.grey[3],
        lineHeight: '17px',
      },
    },
  },
  sectionMessage: {
    maxWidth: custom.form.maxWidth,
    marginBottom: 15,
  },
  heading: {
    marginBottom: 20,
    marginTop: 30,
  },
  compactSectionHeading: {},
  formRow: {},
  formRowWithoutBackGround: {
    backgroundColor: 'transparent !important',
    padding: '0 !important',
  },
  message: {
    border: `2px solid ${palette.common.white}`,
  },
  formRowConsentsCepikAbTestConsent: {
    paddingTop: 5,
    '& span': {
      fontWeight: 'bold !important',
      fontSize: '16px !important',
      lineHeight: '20px !important',
    },
  },
  formRowConsentsCepikAbTestNumberNotKnown: {
    marginBottom: '10px !important',
  },
}));
